/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 0bedcb0b91e0
 */

import * as z from "zod";
import { triggersUpdateTrigger } from "../../funcs/triggersUpdateTrigger.js";
import { UpdateTriggerRequest$zodSchema } from "../../models/updatetriggerrequest.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  id: z.string().describe("The ID of the trigger."),
  update_trigger_request: UpdateTriggerRequest$zodSchema.describe(
    `The updated trigger configuration.`,
  ),
};

export const tool$triggersUpdateTrigger: ToolDefinition<typeof args> = {
  name: "update-trigger",
  description:
    `Updates the callback URL of an existing webhook trigger in your Cloudinary account

Updates a notification URL for a trigger.`,
  scopes: ["admin"],
  annotations: {
    "title": "Update Trigger",
    "destructiveHint": false,
    "idempotentHint": true,
    "openWorldHint": false,
    "readOnlyHint": false,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await triggersUpdateTrigger(
      client,
      args.id,
      args.update_trigger_request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
